import { 
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  ContentChild,
  TemplateRef,
  ElementRef } from '@angular/core';
import { GalleryColumns } from '../../models/gallery-list-columns.enum';
import { environment } from 'src/environments/environment';
import { GalleryViewMode } from '../../models/gallery-view-mode.enum';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';

@Component({
  selector: 'app-gallery-results',
  templateUrl: './gallery-results.component.html',
  styleUrls: ['./gallery-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryResultsComponent implements OnInit {
  @ContentChild('galleryActions', { static: true, read: TemplateRef }) 
  @Input()
  galleryActionsTemplate: TemplateRef<ElementRef>;

  @ContentChild('galleryTags', { static: true, read: TemplateRef }) 
  @Input()
  galleryTagsTemplate: TemplateRef<ElementRef>;

  galleryViewMode = GalleryViewMode;
  
  @Input()
  loading = false;

  @Input()
  viewMode = GalleryViewMode.Cards;

  @Input()
  selectLabel = 'Select';

  @Input()
  public get results(): BookmarkModel[] {
    return this._results;
  }
  public set results(value: BookmarkModel[]) {
    this._results = value;
    this.changeDetectorRef.markForCheck();
  }
  private _results: BookmarkModel[];

  @Input()
  checkable = false;

  @Input()
  showActions = false;

  @Input()
  checkedResults: string[] = [];

  @Output()
  selectBookmark = new EventEmitter<BookmarkModel>();

  @Output()
  checkedChange = new EventEmitter<string[]>();

  columns: GalleryColumns[];

  constructor(
    private changeDetectorRef: ChangeDetectorRef  ) { }

  ngOnInit() {
    switch (environment.exportType) {
      case 'bookmark':
        this.columns = [
          GalleryColumns.Model,
          GalleryColumns.Tags,
          GalleryColumns.CreatedBy,
          GalleryColumns.UpdatedBy,
          GalleryColumns.Actions
        ];
        break;
      case 'module':
        this.columns = [
          GalleryColumns.Model,
          GalleryColumns.Actions
        ];
        break;
    }
  }

  handleSelect(result: BookmarkModel) {
    this.selectBookmark.emit(result);
  }

  handleCheckedChange(ids: string[]) {
    this.checkedChange.emit(ids);
  }
}
